import { render } from "./ActivityTable.vue?vue&type=template&id=2be63dea&scoped=true"
import script from "./ActivityTable.vue?vue&type=script&lang=js"
export * from "./ActivityTable.vue?vue&type=script&lang=js"

import "./ActivityTable.vue?vue&type=style&index=0&id=2be63dea&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2be63dea"]])

export default __exports__